///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2021 - 2023
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import messages from "../../../helpers/messages";

export const NoMatches = ({
  heading = messages.noMatches.defaultMessage,
  message = messages.noLaneMatchMessage.defaultMessage,
  optional,
  button
}) => (
  <div className="flex justify-center text-center items-center panel no-matches-panel">
    <div data-testid="no-matches">
      <p className="uppercase univers-45-light font-size-16 no-matches">
        {heading}
      </p>
      <p className="text-dim-grey font-bold font-size-16">{message}</p>
      {optional && (
        <p className="text-dim-grey font-italic font-size-14">{optional}</p>
      )}
      {button}
    </div>
  </div>
);
